import { render, staticRenderFns } from "./ClaimReportView.vue?vue&type=template&id=3957ada2"
import script from "./ClaimReportView.vue?vue&type=script&lang=js"
export * from "./ClaimReportView.vue?vue&type=script&lang=js"
import style0 from "./ClaimReportView.vue?vue&type=style&index=0&id=3957ada2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports